import client from "./axiosConfig";

export const getESSs = (params) => {
    const config = {
        url: "/ess/documents/",
        method: "GET",
        params
    };
    const response = client(config);
    return response;
};

export const addESS = (data) => {
    const config = {
        url: "/ess/documents/",
        method: "POST",
        data
    };
    const response = client(config);
    return response;
};

export const deleteESSs = (id) => {
    const config = {
        url: `/ess/documents/${id}/`,
        method: "DELETE"
    }
    return client(config);
}

export const getReferrals = (params) => {
    const config ={
        url: '/ess/referral/',
        method: 'GET',
        params
    }
    const response = client(config);
    return response;
}

export const createReferral = (data) => {
    const config = {
        url: '/ess/referral/',
        method: 'POST',
        data
    }
    const response = client(config);
    return response;
}

export const getReferralById = (id) => {
    const config = {
        url: `/ess/referral/${id}/`,
        method: 'GET',
    }
    const response = client(config);
    return response;
}

export const updateReferralById = (id, data) => {
    const config = {
        url: `/ess/referral/${id}/`,
        method: 'PATCH',
        data
    }
    const response = client(config);
    return response;
}

export const getEligibleReferrals = (params) => {
    const config = {
        url: "/ess/referral/eligible/",
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const deleteReferral = (id) => {
    const config = {
        url: `/ess/referral/${id}/`,
        method: "DELETE"
    }
    const response = client(config);
    return response;
}